var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contact)?_c('div',[_vm._v("\n  "+_vm._s(_vm.contact.name)+"\n  "),_c('div',[_vm._v("\n    "+_vm._s(_vm.contact.address)+"\n    "),(_vm.contact.city && _vm.contact.state)?_c('span',[_vm._v(", "+_vm._s(_vm.contact.city)+", "+_vm._s(_vm.contact.state)+" "+_vm._s(_vm.contact.postcode))]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }